import React__default from 'react';
import { useGetTags, KpkFilterType, KpkFilterModifierType, getActiveValues } from '@keepeek/commons';
import { Box, Typography, Chip } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import ActiveFilter from '../ActiveFilter/index.js';
import ActiveReferenceFilter from '../ActiveReferenceFilter/index.js';

var ActiveFilters = function (_a) {
    var filters = _a.filters, className = _a.className, onFilterDelete = _a.onFilterDelete, references = _a.references, sx = _a.sx, KIcon = _a.KIcon;
    var t = useTranslation("refront-components").t;
    var tags = useGetTags();
    if (!filters || filters.length < 1) {
        return null;
    }
    return (React__default.createElement(Box, { className: clsx("ActiveFilters", className), "data-testid": "filters-list", sx: sx }, filters.map(function (filter) {
        var _a, _b, _c, _d;
        var filterIdWithoutLocale = filter.id.split(".")[0];
        // Special filter for not found reference
        if (references &&
            references.all &&
            ((_a = references === null || references === void 0 ? void 0 : references.all) === null || _a === void 0 ? void 0 : _a.length) !== 0 &&
            filter.notFoundReference) {
            return (React__default.createElement(ActiveReferenceFilter, { key: "".concat(filter.id, "-").concat(filter && filter.values && filter.values.length > 0 ? filter.values[0].id : ""), filter: filter, onFilterDelete: onFilterDelete, references: references, KIcon: KIcon }));
        }
        else if (filterIdWithoutLocale === "BASKET-BASKET") {
            // Do not display active basket filter
            return null;
        }
        else {
            var valuesComponent = React__default.createElement(React__default.Fragment, null);
            // Special value for the "date" type filter if the modifier is not "FromTo": we want to obtain a static translation :
            if (filter.type === KpkFilterType.Date &&
                ((_b = filter.modifiers) === null || _b === void 0 ? void 0 : _b.some(function (m) { return m.selected === true && m.type !== KpkFilterModifierType.FromTo; }))) {
                var selectedModifier = filter.modifiers.find(function (m) { return m.selected === true; });
                if (selectedModifier) {
                    valuesComponent = (React__default.createElement(React__default.Fragment, null, t("components.active-filters.".concat(selectedModifier.type, ".label"))));
                }
            }
            else if (filter.type === KpkFilterType.Checkbox &&
                ((_c = filter.modifiers) === null || _c === void 0 ? void 0 : _c.some(function (m) { return m.selected === true && m.type === KpkFilterModifierType.NotEmpty; }))) {
                valuesComponent = (React__default.createElement(Typography, { variant: "caption" }, t("components.filter-checkbox.all.elements.are.checked.label")));
            }
            else if (
            // Specific i18n for tags filter
            filter.type === KpkFilterType.Tags &&
                ((_d = filter.modifiers) === null || _d === void 0 ? void 0 : _d.some(function (m) { return m.selected === true; }))) {
                var selectedModifier = filter.modifiers.find(function (m) { return m.selected === true; });
                if (selectedModifier) {
                    valuesComponent = (React__default.createElement(React__default.Fragment, null,
                        t("components.filter-tags.option.".concat(selectedModifier.type, ".label")),
                        formatActiveFilterTags(tags, filter)));
                }
            }
            else {
                valuesComponent = formatAndTruncateActiveValues(filter);
            }
            return (React__default.createElement(ActiveFilter, { key: "".concat(filter.id, "-").concat(filter && filter.values && filter.values.length > 0 ? filter.values[0].id : ""), filter: filter, valuesComponent: valuesComponent, onFilterDelete: onFilterDelete, KIcon: KIcon }));
        }
    })));
};
var formatAndTruncateActiveValues = function (filter) {
    var activeValues = getActiveValues(filter);
    var values = activeValues.map(function (v) { return v.label; }).join(", ");
    if (values.length > 50) {
        values = "".concat(values.substr(0, 50), "...");
    }
    var titles = activeValues.map(function (v) { return v.title; }).join(", ");
    if (titles.length > 50) {
        titles = "".concat(titles.substr(0, 50), "...");
    }
    return (React__default.createElement(Typography, { variant: "caption", component: "div", title: titles }, values));
};
var formatActiveFilterTags = function (tags, filter) {
    var activeValues = getActiveValues(filter);
    return (React__default.createElement(Box, { sx: {
            display: "flex",
            flexWrap: "wrap",
            gap: 1
        } }, activeValues.map(function (av) {
        var tagWithColor = tags.find(function (t) { return av.id === t.id; });
        if (tagWithColor) {
            return (React__default.createElement(Chip, { key: tagWithColor.id, label: tagWithColor.name, size: "small", title: tagWithColor.name, sx: {
                    backgroundColor: tagWithColor.backgroundColor,
                    color: tagWithColor.textColor
                } }));
        }
        else {
            return null;
        }
    })));
};

export { ActiveFilters as default };
//# sourceMappingURL=index.js.map
